export default "__VITE_ASSET__Dmx$Cp5e__"